import React from "react";
import "./PaymentButton.css";
import getTextColor from "@/utils/getTextColor";

export interface PaymentButtonProps {
  url: string;
  order: string;
  amount: string;
  chatConfig?: any;
  image?: string;
}

export const PaymentButton: React.FC<PaymentButtonProps> = ({
  url,
  order,
  amount,
  chatConfig,
  image,
}) => {
  const handleClick = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const buttonBgColor = chatConfig?.color || "#667eea";
  const themeColor = buttonBgColor;

  return (
    <div className="cbb-payment-button-container">
      <button
        className="cbb-payment-button"
        onClick={handleClick}
        type="button"
        style={{
          background: "#ffffff",
          border: "1px solid #333333",
          color: "#333333",
        }}
      >
        <div className="cbb-payment-button-content">
          {image ? (
            <div className="cbb-payment-image">
              <img src={image} alt="Product" />
            </div>
          ) : (
            <div
              className="cbb-payment-icon"
              style={{ background: `${themeColor}15`, color: themeColor }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          )}
          <span
            className="cbb-payment-title"
            style={{ color: themeColor, fontWeight: "600" }}
          >
            Pay Now
          </span>
        </div>
      </button>
    </div>
  );
};

export default PaymentButton;
